'use client';
import { Header, Spacer, Toaster, Typo } from 'components/ui-kit';
import React, { useState } from 'react';
import { ContactForm } from './components/form/contact-form.component';
import { ContactMap } from './components/map/contact-map.component';
import styles from './contact.module.scss';

export const Contact = (): JSX.Element => {
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <>
      <div className={styles.contactWrapperForm}>
        <Spacer size={60} />
        {isSuccess ? (
          <Typo variant="xl" align="center" weight="600">
            Спасибо! Скоро вернёмся с ответом
          </Typo>
        ) : (
          <>
            <Header level={2} align="center">
              Напишите нам!
            </Header>
            <Spacer size={24} />
            <Typo variant="l" align="center">
              Здесь вы&nbsp;можете задать вопросы о&nbsp;наших товарах, оплате,
              возврате или обмене, написать отзыв. Мы&nbsp;отвечаем
              в&nbsp;рабочие дни с&nbsp;10&nbsp;утра до&nbsp;9&nbsp;вечера.
            </Typo>
            <Spacer size={{ s: 48, sm: 32 }} />
            <ContactForm onSubmit={setIsSuccess} />
          </>
        )}
        <Spacer size={100} />
        <Spacer size={{ s: 184, m: 192, xl: 0 }} />
      </div>
      <ContactMap />
      <Toaster />
    </>
  );
};
